import { ChangeDetectorRef, Component } from '@angular/core';
import { PluginComponent } from '../../plugin.component';
import { Inspection } from '../../../shared/models/inspection.model';

@Component({
    selector: 'installation-incoterms',
    templateUrl: './incoterms.component.html',
    standalone: false
})
export class InstallationIncotermsPluginComponent {
  public incoterms: any;
  public config: any;
  public editRoute = ['installation', 'incoterms', 'edit'];

  constructor(private cdRef: ChangeDetectorRef) {}

  setConfig(config: any, inspection: Inspection, plugin: any) {
    this.config = config;
    this.initData();
    this.cdRef.detectChanges();
  }

  private initData() {
    this.incoterms = this.config.Incoterms;
  }
}
PluginComponent.plugins['installationincoterms'] = InstallationIncotermsPluginComponent;
